import React from 'react'
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form'
import { t } from 'ttag'
import { CompanyId, UserCompanyDto } from '../../../../services/api.types'
import { calculateDuration, FormData } from '../../ChallengeAdmin'

import DateRangeInput from '../ChallengeDateRange/ChallengeDateRange'
import dayjs from '../../../../dayjsConfig'

const MAX_CHALLENGE_DURATION = 366

interface ChallengeStepPeriodProps {
  control: Control<FormData>
  errors: FieldErrors<FormData>
  setValue: UseFormSetValue<FormData>

  companyId: CompanyId
  userCompanies: UserCompanyDto[]
  contractPeriod: any

  contractStartDate: Date | null
  contractEndDate: Date | null
  isUserCreatedChallenge: boolean
}

export default function ChallengeStepPeriod(props: ChallengeStepPeriodProps) {
  const {
    control,
    errors,
    setValue,
    companyId,
    userCompanies,
    contractPeriod,
    contractStartDate,
    contractEndDate,
    isUserCreatedChallenge,
  } = props

  const validateDates = (v: any) => {
    return !!(v[0] && v[1]) && v[1] > v[0]
  }

  const validateDuration = (v: any) => {
    const durationDays = calculateDuration(v[0], v[1])
    return durationDays <= MAX_CHALLENGE_DURATION
  }

  const validateStartDate = (v: any) => {
    if (contractStartDate === null) return true
    return !dayjs(v[0]).startOf('day').isBefore(contractStartDate)
  }

  const validateEndDate = (v: any) => {
    if (contractEndDate === null) return true
    return !dayjs(v[1]).startOf('day').isAfter(contractEndDate)
  }

  const getAccountSalespersonLink = (userCompanies: UserCompanyDto[], companyId: CompanyId) => {
    if (!userCompanies || !companyId) return null
    const userCompany = userCompanies.find((uc) => uc.companyId === companyId)
    if (!userCompany?.salesperson || !userCompany?.salespersonEmail) return null
    const name = userCompany.salesperson
    return <a href={`mailto:${userCompany.salespersonEmail}`}>{t`Send email to ${name}`}</a>
  }

  return (
    <DateRangeInput
      setValue={setValue}
      control={control}
      errors={errors}
      isUserCreatedChallenge={isUserCreatedChallenge}
      salespersonLink={getAccountSalespersonLink(userCompanies, companyId)}
      contractStartDate={contractStartDate}
      contractEndDate={contractEndDate}
      contractPeriod={contractPeriod}
      plan={userCompanies.find((uc) => uc.companyId === companyId)?.plan || ''}
      rules={{
        required: true,
        validate: {
          required: (v: any) => validateDates(v) || t`Start date must be before the end date.`, // 'Both the start and end date are required.',
          duration: (v: any) => validateDuration(v) || t`The maximum challenge period is one year.`,
          startDate: (v: any) => validateStartDate(v) || t`Selected start date is outside of the contract period.`,
          endDate: (v: any) => validateEndDate(v) || t`Selected end date is outside of the contract period.`,
        },
      }}
    />
  )
}
